<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit ${orderType} ${orderModule.order}`
        : `Add ${orderType} ${orderModule.order}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <SecondaryButton
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        btnClass="text-uppercase rounded-lg"
        :disabled="!isValid"
        name="Submit"
        @click="checkIfSubmit"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="orderForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0 pa-0">
          <v-col cols="12" lg="9" class="pa-0 pr-lg-2">
            <v-card elevation="0" class="pa-4 rounded-lg">
              <v-row class="ma-0">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ orderModule.order }} Information
                  </span>
                </v-col>
                <v-col cols="12" md="3">
                  <InputField
                    label="Reference Number"
                    :required="true"
                    v-model="orderDetails.reference_number"
                    :error-messages="formErrors.reference_number"
                    @input="delete formErrors.reference_number"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <SelectField
                    :itemsList="branchList"
                    item-text="name"
                    item-value="id"
                    :label="`${configurationModule.branch}*`"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.branch} is required`,
                    ]"
                    v-model="orderDetails.branch"
                    :error-messages="formErrors.branch"
                    @change="
                      delete formErrors.branch;
                      getCustomerList({ branch: $event });
                      getWarehouseList({ branch: $event });
                      getProjectSelectList($event);
                      getBranchDetail($event);
                    "
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <SelectField
                    :itemsList="projectList"
                    item-text="name"
                    item-value="id"
                    :label="`${configurationModule.project}*`"
                    :required="true"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.project} is required`,
                    ]"
                    v-model="orderDetails.project"
                    :error-messages="formErrors.project"
                    @change="delete formErrors.project"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <DatePicker
                    type="date"
                    outlined
                    :label="`${orderModule.order} Date*`"
                    :min="returnToday()"
                    :rules="[
                      (val) => !!val || `${orderModule.order} Date is required`,
                    ]"
                    v-model="orderDetails.execution_date"
                    :error-messages="formErrors.execution_date"
                    @input="delete formErrors.execution_date"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="
                    userDetails &&
                    userDetails.company_details &&
                    userDetails.company_details.configuration &&
                    !userDetails.company_details.configuration.has_items
                  "
                >
                  <InputField
                    type="number"
                    :label="`${orderModule.order} Volume`"
                    :required="true"
                    v-model="orderDetails.volume"
                    :error-messages="formErrors.volume"
                    @input="delete formErrors.volume"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="
                    userDetails &&
                    userDetails.company_details &&
                    userDetails.company_details.configuration &&
                    !userDetails.company_details.configuration.has_items
                  "
                >
                  <InputField
                    type="number"
                    :label="`${orderModule.order} Weight`"
                    :required="true"
                    v-model="orderDetails.weight"
                    :error-messages="formErrors.weight"
                    @input="delete formErrors.weight"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <InputField
                    :label="`${orderModule.order} Remarks`"
                    v-model="orderDetails.order_remarks"
                    :error-messages="formErrors.order_remarks"
                    @input="delete formErrors.order_remarks"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="
                    orderType == 'Pickup' ||
                    (userDetails &&
                      userDetails.company_details &&
                      userDetails.company_details.configuration &&
                      !userDetails.company_details.configuration.has_items)
                  "
                >
                  <SelectField
                    :itemsList="warehouseList"
                    item-text="name"
                    item-value="id"
                    :label="`${configurationModule.warehouse}*`"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.warehouse} is required`,
                    ]"
                    v-model="orderDetails.warehouse"
                    :error-messages="formErrors.warehouse"
                    @input="delete formErrors.warehouse"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <SelectField
                    :itemsList="customerList"
                    item-text="name"
                    item-value="id"
                    :label="`${customerModule.customer}*`"
                    :rules="[
                      (val) =>
                        !!val || `${customerModule.customer} is required`,
                    ]"
                    v-model="selectedCustomer"
                    @change="customerChanged"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <SelectField
                    :itemsList="customerAddressList"
                    item-text="location_id"
                    item-value="id"
                    :label="`${customerAddressModule.customerAddress}*`"
                    :rules="[
                      (val) =>
                        !!val ||
                        `${customerAddressModule.customerAddress} is required`,
                    ]"
                    v-model="orderDetails.customer_address"
                    :error-messages="formErrors.customer_address"
                    @input="
                      delete formErrors.customer_address;
                      onSelectedLocationID();
                    "
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="orderType == 'Delivery'">
                  <SelectField
                    return-object
                    :itemsList="paymentMethodList"
                    label="Payment Method*"
                    item-text="name"
                    item-value="id"
                    :rules="[(val) => !!val || 'Payment Method is required']"
                    v-model="orderDetails.payment_method"
                    :error-messages="formErrors.payment_method"
                    @input="delete formErrors.payment_method"
                    @change="onPaymentChange"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  class="d-flex"
                  v-if="
                    orderType == 'Delivery' &&
                    orderDetails.payment_method &&
                    orderDetails.payment_method.type != 'prepaid'
                  "
                >
                  <InputField
                    type="number"
                    min="0"
                    :label="`${orderModule.order} Value`"
                    :required="true"
                    class="mr-2"
                    v-model="orderDetails.order_value"
                    :error-messages="formErrors.order_value"
                    @input="delete formErrors.order_value"
                  />
                  <SelectField
                    v-model="orderDetails.currency"
                    :itemsList="currencyList"
                    name="currency"
                    style="width: 200px"
                    itemText="code"
                    itemValue="id"
                    :label="`currency*`"
                    :rules="[(val) => !!val || 'Currency is required']"
                    :isSearchRequired="false"
                    :error-messages="formErrors.currency"
                    @input="delete formErrors.currency"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <SwitchField
                    v-model="orderDetails.customer_barcode_scanning"
                    inset
                    class="mt-3"
                    label="Customer Barcode Scanning Reuqired"
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="orderType == 'Delivery'">
                  <SwitchField
                    v-model="orderDetails.warehouse_barcode_scanning"
                    inset
                    class="mt-3"
                    label="Warehouse Barcode Scanning Reuqired"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="
                    orderDetails.customer_barcode_scanning ||
                    orderDetails.warehouse_barcode_scanning
                  "
                >
                  <InputField
                    label="Barcode Number"
                    v-model="orderDetails.barcode_number"
                    :error-messages="formErrors.barcode_number"
                    @input="delete formErrors.barcode_number"
                    :required="true"
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="orderType == 'Delivery'">
                  <SwitchField
                    v-model="orderDetails.is_proof_of_delivery"
                    inset
                    class="mt-3"
                    label="Order Attachment Required"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <SwitchField
                    v-model="orderDetails.otp_verification"
                    inset
                    class="mt-3"
                    label="Otp Verification Required"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card
              elevation="0"
              class="mt-4 pa-4 rounded-lg"
              v-if="
                userDetails &&
                userDetails.company_details &&
                userDetails.company_details.configuration &&
                userDetails.company_details.configuration.has_items
              "
            >
              <v-row class="ma-0">
                <v-col cols="6" class="d-flex align-center">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ orderModule.order }} Items
                  </span>
                </v-col>
                <v-col cols="6" class="d-flex justify-end align-center">
                  <v-chip class="mr-2 primary" small
                    ><span class="text-capitalize mr-2">total Volume</span
                    >{{ orderCbm }} CBM</v-chip
                  >
                  <v-chip class="mr-6 primary" small
                    ><span class="text-capitalize mr-2">total Weight</span
                    >{{ orderWeight }} Kg</v-chip
                  >
                  <PrimaryButton name="Add Item" @click="addItem()">
                  </PrimaryButton>
                </v-col>
              </v-row>
              <v-row
                class="ma-0"
                v-for="(item, itemIndex) in orderDetails.order_items"
                :key="itemIndex"
              >
                <v-col cols="11" class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="12" lg="3" v-if="orderType == 'Delivery'">
                      <SelectField
                        :itemsList="warehouseList"
                        item-text="name"
                        item-value="id"
                        :label="`${configurationModule.warehouse}*`"
                        :rules="[
                          (val) =>
                            !!val ||
                            `${configurationModule.warehouse} is required`,
                        ]"
                        v-model="item.warehouse"
                        :error-messages="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'warehouse'
                          )
                        "
                        @input="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'warehouse',
                            true
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="12" lg="3">
                      <SelectField
                        :itemsList="itemList"
                        class="custom-list"
                        :class="
                          item && item.status
                            ? 'unassigned lighten-3'
                            : 'background_color'
                        "
                        item-text="item_no"
                        item-value="id"
                        label="Item*"
                        :disabled="item && item.status ? true : false"
                        :return-object="true"
                        :item-disabled="
                          (item) => selectedItemIds.indexOf(item.id) > -1
                        "
                        :rules="[(val) => !!val || 'Item is required']"
                        v-model="item.item"
                        :error-messages="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'item'
                          )
                        "
                        @input="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'item',
                            true
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="12" lg="3">
                      <InputField
                        type="number"
                        label="Quantity"
                        :required="true"
                        :rules="[minOrderQuantity, maxOrderQuantity]"
                        v-model="item.original_quantity"
                        :error-messages="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'original_quantity'
                          )
                        "
                        @input="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'original_quantity',
                            true
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="3" class="d-flex">
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-chip
                            class="w-100 white mr-2"
                            filter
                            label
                            v-on="on"
                            v-bind="attrs"
                            v-show="item.original_quantity"
                          >
                            {{
                              isNaN(calculateItemCbm(item))
                                ? 0
                                : calculateItemCbm(item)
                            }}
                            CBM
                          </v-chip>
                        </template>
                        <span>Items Total Volume</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-chip
                            class="w-100 white mr-2"
                            filter
                            label
                            v-on="on"
                            v-bind="attrs"
                            v-show="item.original_quantity"
                          >
                            {{
                              isNaN(calculateItemWeight(item))
                                ? 0
                                : calculateItemWeight(item)
                            }}
                            KG
                          </v-chip>
                        </template>
                        <span>Items Total Weight</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="1" class="d-flex justify-end align-center">
                  <PrimaryButton
                    :disabled="orderDetails.order_items.length < 2"
                    color="error"
                    @click="removeItem(itemIndex)"
                    name="Remove"
                  >
                  </PrimaryButton>
                </v-col>
              </v-row>
            </v-card>

            <v-row
              class="mt-4 mt-lg-0"
              v-if="customOptionFieldList && customOptionFieldList.length > 0"
            >
              <v-col cols="12">
                <CustomFieldRenderForm
                  :fieldList="customOptionFieldList"
                  :formObject="customObject"
                  :fieldsErrors="customFieldsErrors"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            class="overflow-y-auto pl-2 pt-0"
            style="height: calc(100vh - 190px)"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-expand-transition>
                  <div
                    v-show="isOverloadCBM"
                    class="rounded-lg mb-4"
                    :style="`border: 3px dashed var(--v-error-lighten2)`"
                  >
                    <v-card elevation="0" class="px-4 py-5 error lighten-5">
                      <v-row class="" style="transition: all 0.3s ease">
                        <v-col cols="2" class="text-center">
                          <v-icon color="error lighten-3">
                            mdi-information
                          </v-icon>
                        </v-col>
                        <v-col cols="10" class="d-flex align-center">
                          <h5 class="text-capitalize">
                            Total item CBM is more then vehicle capacity.
                          </h5>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-show="isOverloadWeight"
                    class="rounded-lg mb-3"
                    :style="`border: 3px dashed var(--v-error-lighten2)`"
                  >
                    <v-card elevation="0" class="px-4 py-5 error lighten-5">
                      <v-row class="" style="transition: all 0.3s ease">
                        <v-col cols="2" class="text-center">
                          <v-icon color="error lighten-3">
                            mdi-information
                          </v-icon>
                        </v-col>
                        <v-col cols="10" class="d-flex align-center">
                          <h5 class="text-capitalize">
                            Total item Weight is more then vehicle capacity.
                          </h5>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-expand-transition>
              </v-col>
              <v-col cols="12" v-if="orderDetails && orderDetails.trip_details">
                <v-expansion-panels
                  v-model="tripInfoExpansion"
                  flat
                  class="app-list-card-expansion mb-4"
                >
                  <v-expansion-panel elevation="0" class="ma-0 rounded-lg">
                    <v-expansion-panel-header
                      class="px-3 py-0 ma-0 app-list-card-expansion-header"
                    >
                      <h5 class="text-caption py-2 font-weight-bold">
                        {{ tripModule.trip }} Info
                      </h5>
                    </v-expansion-panel-header>
                    <v-divider></v-divider>
                    <v-expansion-panel-content
                      class="pa-0"
                      v-for="(value, key, index) in orderDetails.trip_details"
                      :key="index"
                    >
                      <v-card
                        elevation="0"
                        class="pa-0 ma-0"
                        v-if="key != 'status'"
                      >
                        <v-card-subtitle class="py-1 ma-0">
                          <v-row no-gutters>
                            <v-col cols="6">
                              <h5 class="text-left text-capitalize" v-if="key">
                                {{ key.replace(/_/g, "  ") }}
                              </h5>
                            </v-col>
                            <v-col cols="6">
                              <h6
                                class="text-caption black--text text-center"
                                v-if="key == 'reference_number'"
                              >
                                {{ value }}
                                <v-chip
                                  class="mr-1 text-capitalize white--text font-weight-bold"
                                  x-small
                                  :class="
                                    $helper.tripStatusColor(tripDetails.status)
                                  "
                                  v-if="tripDetails.status"
                                >
                                  {{ tripDetails.status }}
                                </v-chip>
                              </h6>
                              <h6
                                class="text-caption black--text text-center"
                                v-else
                              >
                                {{ value }}
                              </h6>
                            </v-col>
                          </v-row>
                        </v-card-subtitle>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col
                cols="12"
                v-if="addressDetails && Object.keys(addressDetails).length > 1"
              >
                <v-expansion-panels
                  v-model="addressDetailsExpansion"
                  flat
                  class="app-list-card-expansion"
                >
                  <v-expansion-panel elevation="0" class="ma-0 mb-2 rounded-lg">
                    <v-expansion-panel-header
                      class="px-3 py-0 ma-0 app-list-card-expansion-header"
                    >
                      <h5 class="text-caption py-2 font-weight-bold">
                        Delivery Info
                      </h5>
                    </v-expansion-panel-header>
                    <v-divider></v-divider>
                    <v-expansion-panel-content
                      class="pa-0"
                      v-for="(value, key, index) in addressDetails"
                      :key="index"
                    >
                      <v-card
                        elevation="0"
                        class="pa-0 ma-0"
                        v-if="
                          [
                            'id',
                            'tags',
                            'remarks',
                            'coordinates',
                            'processing_time',
                            'customer',
                          ].indexOf(key) == -1
                        "
                      >
                        <v-card-subtitle class="py-1 ma-0">
                          <v-row no-gutters>
                            <v-col cols="6">
                              <h5 class="text-left text-capitalize" v-if="key">
                                {{ key.replace(/_/g, "  ") }}
                              </h5>
                            </v-col>
                            <v-col cols="6">
                              <h6
                                class="text-caption black--text text-center"
                                v-if="key == 'days' && value"
                              >
                                <div
                                  v-for="(day, dayindex) in value"
                                  :key="dayindex"
                                >
                                  <v-chip
                                    x-small
                                    class="success px-2 text-capitalize"
                                  >
                                    {{ day }}
                                  </v-chip>
                                </div>
                              </h6>
                              <h6
                                class="text-caption black--text text-center"
                                v-else
                              >
                                {{ value }}
                              </h6>
                            </v-col>
                          </v-row>
                        </v-card-subtitle>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import { maxOrderQuantity, minOrderQuantity } from "@/utils/validation.js";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import {
  errorInSubArrayHandler,
  returnToday,
  referenceValidation,
  customFieldDefaultData,
} from "@/utils/functions";
import {
  tripModule,
  orderModule,
  configurationModule,
  customerModule,
  customerAddressModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    BaseFormLayout,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    orderType: {
      required: true,
    },
  },

  data() {
    return {
      customFieldDefaultData,
      referenceValidation,
      tripModule,
      orderModule,
      customerModule,
      configurationModule,
      customerAddressModule,
      errorInSubArrayHandler,
      minOrderQuantity,
      maxOrderQuantity,
      returnToday,
      tripInfoExpansion: 0,
      addressDetailsExpansion: 0,
      fileInput: null,
      formCount: 0,
      isValid: true,
      orderDetails: {
        customer_barcode_scanning: false,
        warehouse_barcode_scanning: false,
      },
      formErrors: {},

      projectList: [],
      addressDetails: {},

      itemList: [],
      branchList: [],
      warehouseList: [],
      customerAddressList: [],
      customerList: [],
      selectedCustomer: null,
      paymentMethodList: [],
      currencyList: [],
      branchDetails: {},
      customOptionFieldList: [],
      customFieldsErrors: {},
      customObject: {},
    };
  },
  computed: {
    orderWeight() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_weight
              ? v.item_weight *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.weight
              ? v.item.weight *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(2);
      }
    },
    orderCbm() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_volume
              ? v.item_volume *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.volume
              ? v.item.volume *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(4);
      }
    },
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
    },
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    selectedItemIds() {
      return this.orderDetails.order_items.map((itemObj) => {
        if (typeof itemObj.item == typeof {}) {
          return itemObj.item.id;
        } else {
          return itemObj.item;
        }
      });
    },
    tripDetails() {
      return this.orderDetails?.trip_details;
    },
    totalCBM() {
      if (
        this.tripDetails &&
        this.tripDetails.status == "scheduled" &&
        this.tripDetails.current_trip_volume
      ) {
        return (
          parseFloat(this.tripDetails.current_trip_volume) +
          parseFloat(this.orderCbm)
        );
      }
    },
    isOverloadCBM() {
      return (
        this.totalCBM &&
        this.tripDetails.vehicle_volume_capacity &&
        this.totalCBM > this.tripDetails.vehicle_volume_capacity
      );
    },
    totalWeight() {
      if (
        this.tripDetails &&
        this.tripDetails.status == "scheduled" &&
        this.tripDetails.current_trip_weight
      ) {
        return (
          (parseFloat(this.tripDetails.current_trip_weight) +
            parseFloat(this.orderWeight)) /
          1000
        );
      }
    },
    isOverloadWeight() {
      return (
        this.totalWeight &&
        this.tripDetails.vehicle_tonnage_capacity &&
        this.totalWeight > this.tripDetails.vehicle_tonnage_capacity
      );
    },
  },
  methods: {
    onPaymentChange(obj) {
      if (obj.type == "prepaid") {
        delete this.orderDetails.order_value;
        delete this.orderDetails.currency;
      } else {
        this.orderDetails = {
          ...this.orderDetails,
          currency: this.branchDetails.currency,
        };
      }
    },
    getBranchDetail(id) {
      this.$api.branch
        .getBranchDetail(id)
        .then((res) => {
          this.branchDetails = res.data;
          this.orderDetails = {
            ...this.orderDetails,
            currency: res.data.currency,
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCurrencyList() {
      bus.$emit("showLoader", true);
      this.$api.currency
        .getCurrencyList({ limit: "all" })
        .then((res) => {
          this.currencyList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    calculateItemWeight(item) {
      if (item.item && item.item.weight) {
        return (
          Math.round(
            (item.original_quantity * parseFloat(item.item.weight) +
              Number.EPSILON) *
              100
          ) / 100
        );
      } else {
        return (
          Math.round(
            (item.original_quantity * parseFloat(item.item_weight) +
              Number.EPSILON) *
              100
          ) / 100
        );
      }
    },
    calculateItemCbm(item) {
      if (item.item && item.item.volume) {
        return parseFloat(
          (item.original_quantity * parseFloat(item.item.volume)).toFixed(4)
        );
      } else {
        return parseFloat(
          (item.original_quantity * parseFloat(item.item_volume)).toFixed(4)
        );
      }
    },
    getCustomerAddressDetails(id) {
      this.$api.customerAddress
        .getCustomerAddressObject(id)
        .then((res) => {
          this.addressDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showToastMessage", {
            content: "Can't fetch data!",
            color: "error",
          });
        });
    },
    onSelectedLocationID() {
      if (this.orderDetails && this.orderDetails.customer_address) {
        this.getCustomerAddressDetails(this.orderDetails.customer_address);
      }
    },
    customerChanged(e) {
      if (e) {
        this.getCustomerAddressList({ customer: e });
      } else {
        this.customerAddressList = [];
        this.orderDetails.customer_address = null;
      }
    },
    addItem() {
      this.orderDetails.order_items.push({});
    },
    removeItem(index) {
      this.orderDetails.order_items.splice(index, 1);
    },
    resetForm() {
      this.selectedCustomer = null;
      this.orderDetails = {
        is_proof_of_delivery: false,
        order_items: [{}],
        branch: this.selectedBranch,
      };
      this.$refs.orderForm.resetValidation();
      this.getOrderOptions();
    },
    getOrderObject(id) {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderObject(id)
        .then((res) => {
          this.orderDetails = res.data;

          if (
            res &&
            res.data &&
            res.data.custom_fields &&
            Object.keys(res.data.custom_fields).length > 0
          ) {
            this.customObject = res?.data?.custom_fields;
          }

          if (this.orderDetails && this.orderDetails.customer_address) {
            this.getCustomerAddressDetails(this.orderDetails.customer_address);
          }
          this.getWarehouseList({ branch: this.orderDetails.branch });
          this.getCustomerList({ branch: this.orderDetails.branch });
          this.selectedCustomer = this.orderDetails.customer;
          this.getCustomerAddressList({ customer: this.orderDetails.customer });
          if (
            this.editMode &&
            this.orderType == "Delivery" &&
            this.orderDetails.payment_method &&
            typeof this.orderDetails.payment_method != "object"
          ) {
            let paymentMethod = this.paymentMethodList.find(
              (p) => p.id == this.orderDetails.payment_method
            );

            if (paymentMethod) {
              this.orderDetails.payment_method = paymentMethod;
            }
            bus.$emit("showLoader", false);
          }
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    checkIfSubmit() {
      if (this.editMode && (this.isOverloadCBM || this.isOverloadWeight)) {
        this.getOrderConfirmation();
      } else {
        this.submitForm();
      }
    },
    async getOrderConfirmation() {
      this.$root
        .$confirm(
          "Order?",
          `Are you sure you want to remove ${orderModule.order} on ${tripModule.trip} OR you can change Quantity ?`,
          { color: "error" }
        )
        .then((confirm) => {
          if (confirm) {
            this.orderDetails.remove_from_trip = true;
            this.submitForm();
            return true;
          } else {
            return false;
          }
        });
    },
    async submitForm() {
      if (!this.$refs.orderForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }

      let data = JSON.parse(JSON.stringify(this.orderDetails));
      data.order_type = this.orderType.toLowerCase();

      data = {
        ...data,
        custom_fields: this.customObject,
      };

      if (this.userDetails.company_details.configuration.has_items) {
        if (data && data.order_items) {
          data.order_items ==
            data.order_items.map((v) => {
              if (!v.status) {
                v.item = v && v.item && v.item.id ? v.item.id : null;
              }
              return v;
            });
        }
      }

      if (
        this.orderType == "Delivery" &&
        typeof data.payment_method === "object"
      ) {
        data.payment_method = data.payment_method.id;
      }
      bus.$emit("showLoader", true);
      if (this.editMode) {
        this.$api.orderNew
          .updateOrderObject(this.orderDetails.id, {
            order_type: this.orderType.toLowerCase(),
            order_segment: "sales",
            has_items: this.userDetails.company_details.configuration.has_items,
            payload: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Order information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = { order_items: [], ...err.data };
            this.customFieldsErrors = err?.data?.custom_fields;
          });
      } else {
        this.$api.orderNew
          .createOrderObject({
            order_type: this.orderType.toLowerCase(),
            order_segment: "sales",
            has_items: this.userDetails.company_details.configuration.has_items,
            payload: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Order created!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = { order_items: [], ...err.data };
            this.customFieldsErrors = err?.data?.custom_fields;
          });
      }
    },
    getBranchList() {
      return this.$api.branch
        .getBranchSelectList({ limit: "all" })
        .then((res) => {
          this.branchList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWarehouseList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      return this.$api.warehouse
        .getWarehouseSelectList(params)
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCustomerAddressList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      return this.$api.customerAddress
        .getCustomerAddressSelectList(params)
        .then((res) => {
          this.customerAddressList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCustomerList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      return this.$api.customer
        .getCustomerSelectList(params)
        .then((res) => {
          this.customerList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPaymentMethodList() {
      return this.$api.paymentMethod
        .getPaymentMethodSelectList({ limit: "all" })
        .then((res) => {
          this.paymentMethodList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getItemList() {
      return this.$api.item
        .getItemSelectList({ limit: "all" })
        .then((res) => {
          this.itemList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProjectSelectList(id) {
      if (id) {
        this.$api.project
          .getProjectSelectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
            let defaultProject = this.projectList.find((v) => v.is_default);
            this.orderDetails.project = defaultProject?.id;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
    getLists() {
      bus.$emit("showLoader", true);
      let allPromises = [this.getBranchList(), this.getPaymentMethodList()];
      if (this.userDetails.company_details.configuration.has_items) {
        allPromises.push(this.getItemList());
      }
      Promise.all(allPromises)
        .then(() => {
          if (this.$route && this.$route.params && this.$route.params.id) {
            this.getOrderObject(this.$route.params.id);
          }
          bus.$emit("showLoader", false);
        })
        .catch(() => {
          bus.$emit("showLoader", false);
        });
    },
    getOrderOptions() {
      bus.$emit("showLoader", true);
      return this.$api.orderNew
        .getOrderOptions({ request_type: "form" })
        .then((res) => {
          this.customOptionFieldList = res?.data?.custom_fields;
          this.customObject = this.customFieldDefaultData(
            this.customOptionFieldList
          );

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  async mounted() {
    await this.getOrderOptions();
    this.getLists();
    this.getCurrencyList();

    // To populate barcode scanning variable using local storage data

    let customerBarcodeScanning =
      this.userDetails?.company_details?.configuration
        ?.customer_barcode_scanning;
    this.orderDetails.customer_barcode_scanning = customerBarcodeScanning;
    if (this.orderType !== "Pickup") {
      let warehouseBarcodeScanning =
        this.userDetails?.company_details?.configuration
          ?.warehouse_barcode_scanning;
      this.orderDetails.warehouse_barcode_scanning = warehouseBarcodeScanning;
    } else {
      this.orderDetails.warehouse_barcode_scanning = false;
    }

    let otpVerification =
      this.userDetails?.company_details?.configuration?.otp_verification;
    this.orderDetails.otp_verification = otpVerification;

    if (this.userDetails.company_details.configuration.has_items) {
      this.orderDetails = {
        ...this.orderDetails,
        order_items: [{}],
      };
      this.formErrors = {
        order_items: [],
      };
    }
    if (this.selectedBranch && !this.editMode) {
      this.orderDetails.branch = this.selectedBranch;
    }
    if (this.selectedBranch) {
      this.getCustomerList({ branch: this.selectedBranch });
      this.getWarehouseList({ branch: this.selectedBranch });
      this.getProjectSelectList(this.selectedBranch);
      this.getBranchDetail(this.selectedBranch);
    }
  },
};
</script>

<style scoped lang="scss">
.v-select__slot label {
  z-index: 2;
}
.custom-list.theme--light.v-select .v-select__selection--disabled {
  color: black !important;
}
</style>
